import { apiClient } from 'services/api';
import { Languages, Translations } from '../../types';

export const fetchTranslations = (language: string): Promise<Translations> =>
  apiClient.get(`/translations/${language}`);

export const fetchLanguages = (): Promise<Languages> => apiClient.get(`/translations`);
